import { withRouter, RouteComponentProps } from 'react-router-dom';

export interface PageProps<Params extends { [K in keyof Params]?: string } = { }> extends RouteComponentProps<Params> {
}

export function withPageProps<P extends PageProps> (component: React.ComponentType<P>) {
    return withRouter(component)
}
